<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading == true" />
                <div class="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="title">Institute Information</h5>
                        </div>
                        <div class="card-body">
                            <select class="form-control custom-dropdown" v-model="selectedMuseum" @change="resetAlerts()">
                                <option disabled selected value="">Select your Institute</option>
                                <option v-for="museum in availableMuseums" :key="museum.id" :value="museum">{{ museum.name }}</option>
                            </select>                           
                            <div class="row mt-5">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Institute Name</label>
                                        <input v-model="selectedMuseum.name" type="text" class="form-control" placeholder="* Name">
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <label>Address</label>
                                    <input v-model="selectedAddress.address_1" type="text" class="form-control" placeholder="* Address">
                                </div>
                                <div class="col-6">
                                    <label>Address 2</label>
                                    <input v-model="selectedAddress.address_2" type="text" class="form-control" placeholder="Address 2">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-3">
                                    <label>City</label>
                                    <input v-model="selectedAddress.city" type="text" class="form-control" placeholder="* City">
                                </div>
                                <div class="col-3">
                                    <label>State</label>
                                    <input v-model="selectedAddress.state" type="text" class="form-control" placeholder="* State">
                                </div>
                                <div class="col-3">
                                    <label>Postal Code</label>
                                    <input v-model="selectedAddress.postal_code" type="text" class="form-control" placeholder="* State">
                                </div>
                                <div class="col-3">
                                    <label>Country</label>
                                    <input v-model="selectedAddress.country" type="text" class="form-control" placeholder="* State">
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-12">
                                    <label>Description:</label>
                                    <textarea v-model="selectedMuseum.description" class="form-control"/>
                                </div>
                            </div>

                            <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                            <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>

                            <div class="row mt-5">
                                <div class="col-6" v-if="selectedMuseum.image != null">
                                    <div class="card">
                                        <div class="card-header">
                                            <p>{{ selectedMuseum.image.split('/').pop() }}</p>
                                        </div>
                                        <div class="card-body">
                                            <img :src="selectedMuseum.image" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                        :options="imageDropzoneOptions" 
                                        :useCustomSlot=true
                                        v-on:vdropzone-sending="appendFileName"
                                        @vdropzone-file-added="fileInDropzone=true"
                                        @vdropzone-removed-file="fileInDropzone=false">
                                        <div class="dropzone-custom-content">
                                            <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                            <div class="subtitle">accepted file types: png jpg jpeg <br><br>Recommended Aspect Ratio: <b>138:95</b></div>
                                        </div>
                                    </Dropzone>
                                    <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                </div>
                            </div>
                                
                            <div class="row">
                                <div class="col-3">
                                    <button class="btn btn-primary" @click="updateMuseum()">Update Institute</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import JWT from '../services/jwt/JWT';
    import Museums from '../controllers/museum.controller';
    import Addresses from '../controllers/addresses.controller';

    import getUID from '../services/firebase/getUID';

    export default {
        name: "EditUserProfile",
        components: {
            Dropzone
        },
        data: function() {
            return {
                imageDropzoneOptions: {
                    url: (process.env.VUE_APP_API_URL + '/listing/upload/' + this.$route.params.listingID) || "http://localhost:3001/api/listing/upload/" + this.$route.params.listingID,
                    maxFilesize: 50, // Mb
                    maxFiles: 1,
                    autoProcessQueue: false,
                    acceptedFiles: '.png,.jpg,.jpeg',
                    header: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                    }
                },
                loading: false,
                errorMessage: '',
                successMessage: '',
                selectedMuseum: {},
                selectedAddress: {},
                availableMuseums: []
            }
        },
        beforeMount: async function() {
            this.loading = true;

            let uid = await getUID(localStorage.getItem('superAdmin'));
            this.availableMuseums = await Museums.getCuratorMuseums(uid);
            this.selectedMuseum = this.availableMuseums[0];
            this.selectedAddress = this.selectedMuseum.address; 
            this.loading = false;
        },
        methods: {
            async updateMuseum() {
                this.loading = true;
                this.errorMessage = "";
                this.successMessage = "";

                let updatedAddress = await Addresses.update(this.selectedAddress.id, this.selectedAddress.address_1, this.selectedAddress.city, this.selectedAddress.state, this.selectedAddress.postal_code, this.selectedAddress.country, this.selectedAddress.address_2);
                
                if (updatedAddress === false) {
                    this.errorMessage = "Something went wrong while updating your institute's address";
                } else if (updatedAddress.error) {
                    this.errorMessage = updatedAddress.error;
                } else {
                    
                    let museumUpdated = await Museums.update(this.selectedMuseum.id, this.selectedMuseum.name, updatedAddress, this.selectedMuseum.description);
                    if (museumUpdated === false) {
                        this.errorMessage = "Something went wrong while updating your institute";
                    } else if (museumUpdated.error) {
                        this.errorMessage = museumUpdated.error;
                    } else {
                        if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                            this.$refs.imageDropzone.processQueue();
                        } else {
                            this.successMessage = "Institute updated successfully";
                        }
                    }
                }

                this.loading = false;
            },

            async appendFileName(file, xhr, formData) {
                file.upload.filename = Date.now() + Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);
                let uploaded = await Museums.uploadImage(this.selectedMuseum.id, file.upload.filename, file.dataURL);
                if (uploaded == false) {
                    this.errorMessage = "Something went wrong with uploading your image"
                } else if (uploaded.error) {
                    this.errorMessage = uploaded.error;
                } else {
                    this.successMessage = "Institute updated successfully";
                    this.selectedMuseum = uploaded;
                    this.$refs.imageDropzone.removeAllFiles();
                }
            },

            removeImage() {
                this.$refs.imageDropzone.removeAllFiles();
            }
        }
    }
</script>